import React, { useEffect, useMemo } from 'react';
import { useNavigate, useLocation, useSearchParams, useParams } from 'react-router-dom';
import { locale, refresh } from '@src/utils/i18n';
import history from "@src/utils/history";

const qs = require('qs');


const RouteLoader = props => {
  const navigate = useNavigate();
  const { element: E, path, isChildRoute } = props;
  const location = useLocation()
  const params = useParams();
  const search = useSearchParams();
  if (!isChildRoute) {
    /* 子路由不设置navigate */
    window.navigateV6 = navigate;
  }
  const query = useMemo(() => qs.parse(location.search, { ignoreQueryPrefix: true }), [location.search])
  history.queryParams.query = query;
  const _props = {
    ...props,
    history,
    match: {
      params,
      search,
      query,
      path
    },
    location
  }
  return <E {..._props} key={`${location.pathname}${location.search}`} />;
};

export default RouteLoader;
